import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';
import { underscoreToSpace } from '../helpers/helpers';

export async function fetchAssignments() {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignments`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function fetchDropboxAssignment(dropboxName, assignmentName) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignments/search?dropbox=${dropboxName}&assignment=${underscoreToSpace(assignmentName)}`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function updateAssignment(assignment) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignments/${assignment.id}`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "PUT";
    baseRequestConfig.body = JSON.stringify(assignment);
    baseRequestConfig.headers['content-type'] = 'application/json';

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}


export async function deleteAssignment(assignmentId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignments/${assignmentId}`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "DELETE";

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function createAssignment(assignment) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignments`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "POST";
    baseRequestConfig.body = JSON.stringify(assignment);
    baseRequestConfig.headers['content-type'] = 'application/json';

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function copyAssignment(assignmentId, dropboxId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignments/${assignmentId}/copy`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "POST";
    baseRequestConfig.body = JSON.stringify({dropbox : dropboxId});
    baseRequestConfig.headers['content-type'] = 'application/json';

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function copyAllAssignments(sourceDropboxId, destinationDropboxId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/dropboxes/${sourceDropboxId}/assignments/copy`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "POST";
    baseRequestConfig.body = JSON.stringify({dropbox : destinationDropboxId});
    baseRequestConfig.headers['content-type'] = 'application/json';

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}


/** WEBPACK FOOTER **
 ** ./src/connectivity/api.assignments.js
 **/